import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMessageSquare, FiMapPin, FiNavigation, FiHome } = FiIcons;

const steps = [
  [FiMessageSquare, 'Dinos qué necesitas', 'Selecciona el tipo de mandado o escríbenos directamente.'],
  [FiMapPin, 'Indica dónde buscarlo', 'Dinos el comercio, farmacia, casa o lugar de recogida.'],
  [FiNavigation, 'Nosotros vamos', 'Un Muchacho E’ Mandao realiza tu diligencia.'],
  [FiHome, 'Recibe tu pedido', 'Lo llevamos hasta el destino indicado.']
];

function HowItWorks() {
  return (
    <section className="how section" id="como-funciona">
      <div className="container">
        <div className="section-heading">
          <span className="eyebrow">Pedir es fácil</span>
          <h2>Hacer un mandao es <em>así de fácil.</em></h2>
        </div>
        <div className="how__route" aria-hidden="true"><span /></div>
        <div className="how__grid">
          {steps.map(([icon, title, text], index) => (
            <motion.article
              className="how-step"
              key={title}
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.35 }}
              transition={{ delay: index * 0.12 }}
            >
              <span className="how-step__number">{index + 1}</span>
              <span className="how-step__icon"><SafeIcon icon={icon} /></span>
              <h3>{title}</h3>
              <p>{text}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;